// extracted by mini-css-extract-plugin
export default {"LinkSectionContainer":"LinkSection_LinkSectionContainer__NBese","Icon":"LinkSection_Icon__9E9i8","Link":"LinkSection_Link__jC51m","Label":"LinkSection_Label__DC7fD"};